import {css} from "@panda/css";

import {CenterBox, Container} from "@pg-design/grid-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {getFlatTypeGenitivePluralLabel} from "../utils/get_flat_type_genitive_label";
import {useDistrictRows} from "../utils/use_district_rows";
import {PricesDistrictsCarousel} from "./prices_districts/PricesDistrictsCarousel";
import {PricesDistrictsTable} from "./prices_districts/PricesDistrictsTable";
import {PricesCityViewSectionTracker} from "./PricesCityViewSectionTracker";
import {usePricesContext} from "./PricesContextFilterProvider";
import {RoomsFilterSelect} from "./RoomsFilterSelect";

interface Props {
    region: IRegionReportPrice;
    type: PricesViewType;
}

export const PricesDistricts = (props: Props) => {
    const {region, type} = props;
    const {districtRooms} = usePricesContext();
    const {districts, dateLabel, yearAgoDateLabel, isLoading} = useDistrictRows(region, type, districtRooms);

    if (isLoading) {
        return (
            <Container className={containerStyle}>
                <CenterBox height="300px">
                    <Loader size="lg" />
                </CenterBox>
            </Container>
        );
    }

    if (!districts || districts.length === 0) {
        return null;
    }

    const summaryLabel = dateLabel ? (
        <>
            Średnie ceny ofertowe nowych {getFlatTypeGenitivePluralLabel(districtRooms)} w dzielnicach {region.name_declension_what} — stan na {dateLabel}
        </>
    ) : null;

    return (
        <Container className={containerStyle}>
            <PricesCityViewSectionTracker sectionName="districts_table" location="rp_apartment_prices_city" />

            <div className={headerRowStyle}>
                <div>
                    <Text variant="headline_3" as="h2" mb={0.5}>
                        Średnie ceny mieszkań w dzielnicach {region.name_declension_what}
                    </Text>

                    {summaryLabel && (
                        // Desktop shows this same text as the table's own <caption> instead
                        <Text variant="info_txt_1" color="var(--colors-gray-700)" className={mobileSummaryStyle}>
                            {summaryLabel}
                        </Text>
                    )}
                </div>

                <RoomsFilterSelect instanceId="prices-districts-rooms-select" sectionName="districts_table" location="rp_apartment_prices_city" independent />
            </div>

            <PricesDistrictsTable
                districts={districts}
                citySlug={region.slug}
                type={type}
                dateLabel={dateLabel}
                yearAgoDateLabel={yearAgoDateLabel}
                caption={summaryLabel}
            />
            <PricesDistrictsCarousel districts={districts} citySlug={region.slug} type={type} yearAgoDateLabel={yearAgoDateLabel} />
        </Container>
    );
};

const containerStyle = css({
    my: 4.5,

    md: {
        my: 8
    },
    lg: {
        px: 10
    }
});

const headerRowStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 1.5,

    md: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between"
    }
});

const mobileSummaryStyle = css({
    md: {display: "none"}
});
import {css} from "@panda/css";

import {CenterBox, Container} from "@pg-design/grid-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {getFlatTypeGenitivePluralLabel} from "../utils/get_flat_type_genitive_label";
import {useDistrictRows} from "../utils/use_district_rows";
import {PricesDistrictsCarousel} from "./prices_districts/PricesDistrictsCarousel";
import {PricesDistrictsTable} from "./prices_districts/PricesDistrictsTable";
import {PricesCityViewSectionTracker} from "./PricesCityViewSectionTracker";
import {usePricesContext} from "./PricesContextFilterProvider";
import {RoomsFilterSelect} from "./RoomsFilterSelect";

interface Props {
    region: IRegionReportPrice;
    type: PricesViewType;
}

export const PricesDistricts = (props: Props) => {
    const {region, type} = props;
    const {districtRooms} = usePricesContext();
    const {districts, dateLabel, yearAgoDateLabel, isLoading} = useDistrictRows(region, type, districtRooms);

    if (isLoading) {
        return (
            <Container className={containerStyle}>
                <CenterBox height="300px">
                    <Loader size="lg" />
                </CenterBox>
            </Container>
        );
    }

    if (!districts || districts.length === 0) {
        return null;
    }

    const summaryLabel = dateLabel ? (
        <>
            Średnie ceny ofertowe nowych {getFlatTypeGenitivePluralLabel(districtRooms)} w dzielnicach {region.name_declension_what} — stan na {dateLabel}
        </>
    ) : null;

    return (
        <Container className={containerStyle}>
            <PricesCityViewSectionTracker sectionName="districts_table" location="rp_apartment_prices_city" />

            <div className={headerRowStyle}>
                <div>
                    <Text variant="headline_3" as="h2" mb={0.5}>
                        Średnie ceny mieszkań w dzielnicach {region.name_declension_what}
                    </Text>

                    {summaryLabel && (
                        // Desktop shows this same text as the table's own <caption> instead
                        <Text variant="info_txt_1" color="var(--colors-gray-700)" className={mobileSummaryStyle}>
                            {summaryLabel}
                        </Text>
                    )}
                </div>

                <RoomsFilterSelect instanceId="prices-districts-rooms-select" sectionName="districts_table" location="rp_apartment_prices_city" independent />
            </div>

            <PricesDistrictsTable
                districts={districts}
                citySlug={region.slug}
                type={type}
                dateLabel={dateLabel}
                yearAgoDateLabel={yearAgoDateLabel}
                caption={summaryLabel}
            />
            <PricesDistrictsCarousel districts={districts} citySlug={region.slug} type={type} yearAgoDateLabel={yearAgoDateLabel} />
        </Container>
    );
};

const containerStyle = css({
    my: 4.5,

    md: {
        my: 8
    },
    lg: {
        px: 10
    }
});

const headerRowStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    mb: 1.5,

    md: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between"
    }
});

const mobileSummaryStyle = css({
    md: {display: "none"}
});
